import {IPostBlog} from 'src/app/interfaces/IPostBlog';
import {UtilityService} from './utility.service';
import {Deals, IDeal} from '../interfaces/IDeal';
import {BehaviorSubject, Observable, retry} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {finalize, map} from 'rxjs/operators';
import {Platform, ToastController} from '@ionic/angular';
import {FCM} from '@capacitor-community/fcm';
import {Router} from '@angular/router';
import {IDataNotification, INotificationForList, INotificationForLists} from '../interfaces/INotification';
import {ActionPerformed, PushNotifications, PushNotificationSchema, Token} from '@capacitor/push-notifications';
import {LABEL} from '../constants/label.constant';
import {IUserLikes} from '../interfaces/IUserLikes';
import {BlogService} from './blog.service';
import {UTILITY} from '../components/utility/utility.component';
import {NotificationsSettingsDefault} from '../constants/stub-value.constant';
import {INotificationsSetting} from '../interfaces/INotificationsSetting';
import {IUserFavoriteProduct} from '../interfaces/IUserFavoriteProduct';
import {ITag, Tags} from '../interfaces/ITag';
import {StorageService} from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class DealService {
    private readonly http = inject(HttpClient);
    private readonly storageService = inject(StorageService);
    private readonly router = inject(Router);
    private readonly blogService = inject(BlogService);
    private readonly utilityService = inject(UtilityService);
    private readonly toastController = inject(ToastController);
    private readonly platform = inject(Platform);

    urlApi = environment.urlApi;
    public deal: IDeal | null = null;
    public childrenDealsList: IDeal[] = [];
    public goToComment = false;
    public postBlog: IPostBlog | null = null;
    public tokenDevice?: string;
    public tags: ITag[] = [];
    public openFromNotification = false;
    public notificationsSettingsDefault: INotificationsSetting[] = JSON.parse(JSON.stringify(NotificationsSettingsDefault));

    public flagSearch = new BehaviorSubject<boolean>(false);
    public flagSearch$ = this.flagSearch.asObservable();
    public dealsList = new BehaviorSubject<IDeal[]>([]);
    public dealsList$ = this.dealsList.asObservable();
    public inEvidenceList = new BehaviorSubject<any[]>([]);
    public inEvidenceList$ = this.inEvidenceList.asObservable();
    public dealsFavoritesList = new BehaviorSubject<IDeal[]>([]);
    public dealsFavoritesList$ = this.dealsFavoritesList.asObservable();
    public notificationsSettingsList = new BehaviorSubject<INotificationsSetting[]>([]);
    public notificationsSettingsList$ = this.notificationsSettingsList.asObservable();
    public maxImageHeight = new BehaviorSubject<number>(200);
    public maxImageHeight$ = this.maxImageHeight.asObservable();
    public approxItemHeight = new BehaviorSubject<number>(400);
    public approxItemHeight$ = this.approxItemHeight.asObservable();
    public approxItemHeightPostBlog = new BehaviorSubject<number>(200);
    public enterHome = new BehaviorSubject<boolean>(false);
    public showBottomSheet = new BehaviorSubject<number>(0);
    public showBottomSheet$ = this.showBottomSheet.asObservable();
    public heightColumn = new BehaviorSubject<number>(130);
    public heightColumn$ = this.heightColumn.asObservable();
    public openKeyboard = new BehaviorSubject<boolean>(false);
    public openKeyboard$ = this.openKeyboard.asObservable();
    public scanActive = new BehaviorSubject<boolean>(false);
    public scanActive$ = this.scanActive.asObservable();
    public tabSelected = new BehaviorSubject<string>('deals-list');
    public tabSelected$ = this.tabSelected.asObservable();
    public notificationsList = new BehaviorSubject<INotificationForList[]>([]);
    public notificationsList$ = this.notificationsList.asObservable();
    public userLikesList = new BehaviorSubject<IUserLikes | null>(null);
    public userLikesList$ = this.userLikesList.asObservable();
    public segmentSavedListSelected = new BehaviorSubject<string>(LABEL.FAVORITES_LIST);

    constructor() {
    }

    public initPush(): void {
        this.registerPush();
    }

    private async registerPush(): Promise<void> {
        try {
            const permission = await PushNotifications.requestPermissions();
            if (permission.receive) {
                await PushNotifications.register();
                const firstRunKey = 'firstRunPromoManiaApp' + environment.storageVersion;
                const firstRun = await this.storageService.get(firstRunKey);
                firstRun ? this.normalRun() : this.firstRun();
            } else {
                this.utilityService.showAlertPermessiNotifiche();
            }
        } catch {
        }
        this.listenRegistration();
        this.listenPushReceived();
        this.listenPushAction();
    }

    private listenRegistration(): void {
        PushNotifications.addListener('registration', async (token: Token) => {
            this.tokenDevice = token.value;
            if (this.tokenDevice) {
                const key = 'tokenDevicePromoMania';
                const stored = await this.storageService.get(key);
                if (!stored) {
                    await this.storageService.set(key, this.tokenDevice);
                    this.syncStoredFavorites();
                } else if (this.tokenDevice !== stored) {
                    await this.storageService.set(key, this.tokenDevice);
                    this.syncStoredFavorites(stored as string);
                }
            }
        });
        PushNotifications.addListener('registrationError', () => {
        });
    }

    private async syncStoredFavorites(oldToken?: string): Promise<void> {
        const list = (await this.storageService.get('storageFavoritesList')) as IDeal[];
        if (Array.isArray(list) && list.length) {
            oldToken ? this.syncFavoritesListOnDB(list, oldToken) : this.syncFavoritesListOnDB(list);
        }
    }

    private listenPushReceived(): void {
        PushNotifications.addListener(
            'pushNotificationReceived',
            (notification: PushNotificationSchema) => {
                const data = notification.data as IDataNotification;
                if (!data?.typeToOpen) {
                    return;
                }
                if (data.isComment) {
                    this.presentToastNotificationCommento(
                        'un\'offerta',
                        String(data.idToOpen),
                        data.typeToOpen
                    );
                } else if (data.typeToOpen === LABEL.FAVORITES_LIST) {
                    this.presentToastNotificationFavoritesList();
                } else if (data.typeToOpen === 'nuove-offerte') {
                    this.presentToastNotificationNuoveOfferte();
                } else {
                    this.presentToastNotification(data.typeToOpen);
                }
            }
        );
    }


    private listenPushAction(): void {
        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (action: ActionPerformed) => this.onPushAction(action)
        );
    }

    private async onPushAction(action: ActionPerformed): Promise<void> {
        this.openFromNotification = true;
        try {
            await this.platform.ready();
            const data = action.notification?.data as IDataNotification;
            if (!data?.typeToOpen) {
                return this.simpleOpenApp();
            }
            switch (data.typeToOpen) {
                case LABEL.DEAL_DETAIL:
                    this.handleDealDetailNotification(String(data.idToOpen));
                    break;
                case LABEL.COMMUNICATION_DETAIL:
                    this.handleCommunicationNotification(String(data.idToOpen));
                    break;
                case LABEL.TUTORIAL_DETAIL:
                    this.handleTutorialNotification(String(data.idToOpen));
                    break;
                default:
                    this.simpleOpenApp();
            }
        } catch {
            this.simpleOpenApp();
        }
    }

    private handleDealDetailNotification(id: string): void {
        this.getAllDeals(true).subscribe({
            next: deals => {
                this.dealsList.next(deals);
                this.getAllInEvidences(true).subscribe({next: ev => this.inEvidenceList.next([...ev])});
                this.getAllNotifications(true).subscribe({
                    next: notifs => {
                        this.notificationsList.next(notifs);
                    },
                    error: err => {
                        this.errorOpenApp(105, err);
                    }
                });
                setTimeout(() => {
                    this.navigateToDeal(deals, id);
                }, 100);
            },
            error: (err) => {
                this.errorOpenApp(106, err);
            }
        });
    }

    private navigateToDeal(deals: IDeal[], id: string): void {
        const idx = Number(id);
        const deal = deals.find(d => d.id === idx);
        if (deal?.childrenDeals?.length) {
            this.childrenDealsList = deal.childrenDeals;
            this.router.navigate(['/children-deals-list', deal.id]);
        } else if (deal) {
            this.deal = deal;
            this.router.navigate(['/deal-detail', deal.id]);
        } else {
            this.router.navigate(['/home/deals-list']).then(() => this.tabSelected.next('deals-list'));
        }
        setTimeout(() => (this.openFromNotification = false), 300);
    }

    private handleCommunicationNotification(id: string): void {
        this.blogService.getAllCommunications(true).subscribe({
            next: list => {
                this.blogService.communicationsList.next(list);
                this.getAllInEvidences(true).subscribe({next: ev => this.inEvidenceList.next([...ev])});
                this.getAllNotifications(true).subscribe({next: notifs => this.notificationsList.next(notifs)});
                setTimeout(() => this.openPostDetail('post-blog-detail', LABEL.COMMUNICATION_DETAIL, id), 100);
            },
            error: (err) => {
                this.errorOpenApp(107, err).then(() => {
                });
            }
        });
    }

    private handleTutorialNotification(id: string): void {
        this.blogService.getAllTutorials(true).subscribe({
            next: list => {
                this.blogService.tutorialsList.next(list);
                this.getAllInEvidences(true).subscribe({next: ev => this.inEvidenceList.next([...ev])});
                this.getAllNotifications(true).subscribe({next: notifs => this.notificationsList.next(notifs)});
                setTimeout(() => this.openPostDetail('post-blog-detail', LABEL.TUTORIAL_DETAIL, id), 100);
            },
            error: (err) => {
                this.errorOpenApp(114, err).then(() => {
                });
            }
        });
    }

    private openPostDetail(route: string, label: string, id?: string): void {
        if (id) {
            this.router.navigate([`/${route}`, label, id]);
        } else {
            this.router.navigate(['/home/blog']).then(() => this.tabSelected.next('blog'));
        }
        setTimeout(() => (this.openFromNotification = false), 300);
    }

    private async simpleOpenApp(): Promise<void> {
        await this.router.navigate(['/home/deals-list']).then(() => this.tabSelected.next('deals-list'));
        this.getAllDeals(true).subscribe({
            next: deals => {
                this.dealsList.next(deals);
                this.getAllNotifications(true).subscribe({
                    next: notifs => this.notificationsList.next(notifs),
                    error: (err) => {
                        this.errorOpenApp(115, err).then(() => {
                        });
                    }
                });
                window.location.reload();
                setTimeout(() => (this.openFromNotification = false), 500);
            },
            error: err => {
                window.location.reload();
                setTimeout(() => {
                    this.errorOpenApp(116, err);
                    this.openFromNotification = false;
                }, 500);
            }
        });
    }

    async errorOpenApp(code: number, error: any): Promise<void> {
        await this.router.navigate(['/home/deals-list']).then(() => this.tabSelected.next('deals-list'));
        await this.utilityService.presentAlertErrorGeneric(code, error);
        setTimeout(() => {
            this.openFromNotification = false;
        }, 500);
    }

    firstRun(): void {
        this.resetNotifiche();
        this.subscribeTo('promomania', null, false);
        this.storageService.set('notificationList' + environment.storageVersion, this.notificationsSettingsDefault);
        this.notificationsSettingsList.next(this.notificationsSettingsDefault);
        this.storageService.set('firstRunPromoManiaApp' + environment.storageVersion, true);
    }

    normalRun(): void {
        this.storageService.get('notificationList' + environment.storageVersion).then(notificationList => {
            if (
                UTILITY.checkObj(notificationList) &&
                this.checkNotificationsList(notificationList, this.notificationsSettingsDefault)
            ) {
                this.notificationsSettingsDefault = notificationList as INotificationsSetting[];
                this.notificationsSettingsList.next(this.notificationsSettingsDefault);
            } else if (UTILITY.checkObj(notificationList) && notificationList.length > 0) {
                this.syncNewNotification(notificationList);
            } else {
                this.resetNotifiche();
                this.notificationsSettingsList.next(this.notificationsSettingsDefault);
                this.storageService.set('notificationList' + environment.storageVersion, this.notificationsSettingsDefault);
            }
        });
    }

    checkNotificationsList(a: any, b: any): boolean {
        return (
            Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val: any, i: number) => val.label === b[i].label) &&
            this.checkIsSameNotificationList(a, b)
        );
    }

    checkIsSameNotificationList(notificationList: INotificationsSetting[], defaults: INotificationsSetting[]): boolean {
        for (let i = 0; i < notificationList.length; i++) {
            if (notificationList[i].children.length !== defaults[i].children.length) {
                return false;
            }
        }
        return true;
    }

    resetNotifiche(): void {
        this.notificationsSettingsDefault = JSON.parse(JSON.stringify(NotificationsSettingsDefault));
        this.notificationsSettingsDefault.forEach((notifica, indexN) => {
            notifica.children.forEach((children, indexC) => {
                if (children.id !== 100) {
                    if (children.active) {
                        indexN === this.notificationsSettingsDefault.length - 1 && indexC === notifica.children.length - 1
                            ? this.subscribeTo(children.topic, this.notificationsSettingsDefault, false)
                            : this.subscribeTo(children.topic, null, false);
                    } else {
                        indexN === this.notificationsSettingsDefault.length - 1 && indexC === notifica.children.length - 1
                            ? this.unsubscribeFrom(children.topic, this.notificationsSettingsDefault, false)
                            : this.unsubscribeFrom(children.topic, null, false);
                    }
                }
            });
        });
    }

    syncNewNotification(notificationList: INotificationsSetting[]): void {
        // 1) Mappa per accedere allo setting per label in O(1)
        const settingsMap = new Map<string, INotificationsSetting>(
            this.notificationsSettingsDefault.map(def => [def.label, def])
        );

        // 2) Per ogni item ricevuto, aggiorna i figli corrispondenti
        for (const item of notificationList) {
            const def = settingsMap.get(item.label);
            if (!def) {
                continue;
            }

            // 2a) Mappa topic → active
            const activeMap = new Map(item.children.map(ch => [ch.topic, ch.active]));

            // 2b) Aggiorna i figli in un solo livello di callback
            def.children.forEach(dch => {
                const act = activeMap.get(dch.topic);
                if (act !== undefined) {
                    dch.active = act;
                }
            });
        }

        // 3) Commit finale
        const updated = Array.from(settingsMap.values());
        this.notificationsSettingsDefault = updated;
        this.notificationsSettingsList.next(updated);
        this.storageService.set(
            'notificationList' + environment.storageVersion,
            updated
        );
    }


    subscribeTo(topicName: string, _: INotificationsSetting[] | null, dismiss: boolean): void {
        PushNotifications.register()
            .then(() => FCM.subscribeTo({topic: topicName}))
            .then(() => {
                if (dismiss) {
                    setTimeout(() => this.utilityService.valueOfLoading(-1), 500);
                }
            })
            .catch(() => {
                if (dismiss) {
                    setTimeout(() => {
                        this.resetNotifiche();
                        this.utilityService.presentToastNotificationError();
                        this.utilityService.valueOfLoading(-1);
                    }, 500);
                }
            });
    }

    unsubscribeFrom(topicName: string, _: INotificationsSetting[] | null, dismiss: boolean): void {
        FCM.unsubscribeFrom({topic: topicName})
            .then(() => {
                if (dismiss) {
                    setTimeout(() => this.utilityService.valueOfLoading(-1), 500);
                }
            })
            .catch(() => {
                if (dismiss) {
                    setTimeout(() => {
                        this.resetNotifiche();
                        this.utilityService.presentToastNotificationError();
                        this.utilityService.valueOfLoading(-1);
                    }, 500);
                }
            });
    }

    getAllDeals(firstAccess?: boolean): Observable<IDeal[]> {
        const link = firstAccess
            ? `${this.urlApi}${environment.DEAL_GET_LIST_APP_FIRST_ACCESS}`
            : `${this.urlApi}${environment.DEAL_GET_LIST_APP}`;

        return this.http.get<Deals>(link).pipe(
            // riprova fino a 5 volte, con 1s di delay tra ogni tentativo
            retry({count: 5, delay: 1000}),
            map(res => res.data)
        );
    }

    getDealById(id: string): Observable<IDeal> {
        return this.http.get<{ data: IDeal }>(`${this.urlApi}${environment.DEAL_GET_BY_ID}/${id}`).pipe(
            map(res => res.data)
        );
    }

    getAllNotifications(firstAccess?: boolean): Observable<INotificationForList[]> {
        const link = firstAccess
            ? `${this.urlApi}${environment.NOTIFICATION_GET_ALL_FIRST_ACCESS}`
            : `${this.urlApi}${environment.NOTIFICATION_GET_ALL}`;

        return this.http.get<INotificationForLists>(link).pipe(
            // riprova fino a 5 volte, con 1s di delay tra ogni tentativo
            retry({count: 5, delay: 1000}),
            map(res => res.data)
        );
    }

    getUserFavoriteProductListByUserToken(): Observable<IUserFavoriteProduct[]> {
        return this.http.post<{ data: IUserFavoriteProduct[] }>(
            this.urlApi + environment.USER_FAVORITE_PRODUCT_LIST_GET_LIST_BY_TOKEN,
            {userToken: this.tokenDevice}
        ).pipe(map(res => res.data));
    }

    apiAmazon5(productIdNumber: string): Observable<any> {
        return this.http.post<{ data: any }>(
            `${this.urlApi}${environment.AMAZON_GET_PRODUCT_INFO}`,
            {productIdNumber}
        ).pipe(
            // fino a 5 tentativi in caso di errore, con 1s di delay tra uno e l'altro
            retry({count: 5, delay: 1000}),
            map(res => res.data)
        );
    }

    addProductToFavoritesListMoreKeepa(
        productIdNumber: string,
        desiredPrice: number,
        alwaysNotify: boolean,
        store?: string
    ): Observable<any> {
        const userToken = this.tokenDevice || 'web-test';
        return this.http.post<any>(
            `${this.urlApi}${environment.USER_FAVORITE_PRODUCT_LIST_CREATE_OR_UPDATE}`,
            {userToken, productIdNumber, desiredPrice, alwaysNotify, store}
        ).pipe(
            // riprova fino a 5 volte, con 1s di delay tra un tentativo e l'altro
            retry({count: 5, delay: 1000})
        );
    }

    deleteProductToFavoritesList(productIdNumber: string): Observable<any> {
        if (!this.tokenDevice) {
            this.storageService.get('tokenDevicePromoMania')
                .then(tok => this.tokenDevice = tok);
        }

        return this.http.post<any>(
            `${this.urlApi}${environment.USER_FAVORITE_PRODUCT_LIST_DELETE}`,
            {userToken: this.tokenDevice, productIdNumber}
        ).pipe(
            retry({
                count: 5,      // massimo 5 tentativi
                delay: 1000    // 1s di ritardo tra un retry e l’altro
            })
        );
    }

    deleteAllFavoritesListByTokenDevice(tokenDevice: string): Observable<any> {
        return this.http.post<any>(
            `${this.urlApi}${environment.USER_FAVORITE_PRODUCT_LIST_DELETE_BY_USER_TOKEN}`,
            {userToken: tokenDevice}
        ).pipe(
            retry({
                count: 5,    // fino a 5 tentativi
                delay: 1000  // 1s di intervallo
            })
        );
    }

    syncFavoritesListWithAllDeals(totalDeals: IDeal[], totalFavoritesDeals: IDeal[]): void {
        if (!totalFavoritesDeals) {
            return;
        }
        const aviable: IDeal[] = [];
        const notAviable: IDeal[] = [];
        totalFavoritesDeals.forEach(fav => {
            const found = totalDeals.find(d => d.productIdNumber === fav.productIdNumber);
            if (found) {
                found.aviable = true;
                aviable.push(found);
            } else {
                fav.aviable = false;
                notAviable.push(fav);
            }
        });
        const finalList = [...aviable, ...notAviable];
        this.storageService.set('storageFavoritesList', finalList).then(() => {});
        this.dealsFavoritesList.next(finalList);
    }

    syncFavoritesListOnDB(favoritesDeals: IDeal[], oldTokenDevice?: string): void {
        if (oldTokenDevice) {
            this.deleteAllFavoritesListByTokenDevice(oldTokenDevice)
                .pipe(
                    finalize(() => this.recursiveCreateUserFavoriteProduct(favoritesDeals, 0))
                )
                .subscribe();
        } else {
            this.getUserFavoriteProductListByUserToken().subscribe({
                next: (userList: IUserFavoriteProduct[]) => {
                    let needsSync = userList.length !== favoritesDeals.length ||
                        !userList.every(u => favoritesDeals.some(f => f.productIdNumber === u.productIdNumber));
                    if (needsSync) {
                        this.deleteAllFavoritesListByTokenDevice(oldTokenDevice)
                            .pipe(
                                finalize(() => this.recursiveCreateUserFavoriteProduct(favoritesDeals, 0))
                            )
                            .subscribe();
                    }
                },
                error: () => {
                    this.recursiveCreateUserFavoriteProduct(favoritesDeals, 0);
                }
            });
        }
    }

    private recursiveCreateUserFavoriteProduct(list: IDeal[], index: number): void {
        if (index >= list.length) {
            return;
        }

        const item = list[index];
        const priceText = item.desiredPrice || item.finalPrice;
        let desired = 0;
        if (UTILITY.checkText(priceText)) {
            desired = UTILITY.importToNumber(priceText) * 100;
        }

        this.addProductToFavoritesListMoreKeepa(
            item.productIdNumber,
            desired,
            item.alwaysNotify,
            item.store
        ).subscribe({
            next: () => this.recursiveCreateUserFavoriteProduct(list, index + 1),
            error: () => this.recursiveCreateUserFavoriteProduct(list, index + 1)
        });
    }


    reportDeal(productIdNumber: string, report: number): Observable<any> {
        const link = this.urlApi +
            (report === 0
                ? environment.DEAL_REPORT_FINISHED
                : environment.DEAL_REPORT_ERROR);

        return this.http.post<string>(link, {productIdNumber}).pipe(
            retry({
                count: 5,       // fino a 5 retry
                delay: 1000     // 1 s di attesa tra un tentativo e l’altro
            })
        );
    }

    getAllInEvidences(firstAccess?: boolean): Observable<any[]> {
        let link = this.urlApi + environment.IN_EVIDENCE_GET_ALL;
        if (firstAccess) {
            link = this.urlApi + environment.IN_EVIDENCE_GET_ALL_FIRST_ACCESS;
        }
        return this.http.get<{ data: any[] }>(link).pipe(map(res => res.data));
    }

    stretchLink(url: string): Observable<string> {
        return this.http.post(this.urlApi + environment.UTILITY_STRETCH_LINK, {url}, {responseType: 'text'});
    }

    listTags(firstAccess?: boolean): Observable<ITag[]> {
        let link = this.urlApi + environment.AFFILIATE_TAG_GET_ALL;
        if (firstAccess) {
            link = this.urlApi + environment.AFFILIATE_TAG_GET_ALL_FIRST_ACCESS;
        }
        return this.http.get<Tags>(link).pipe(
            // fino a 5 tentativi in caso di errore, con 1s di delay tra uno e l'altro
            retry({count: 5, delay: 1000}),
            map(res => res.data)
        );
    }

    async presentToastNotificationCommento(type: string, idToOpen: string, typeToOpen: string): Promise<void> {
        const toast = await this.toastController.create({
            color: 'medium',
            icon: 'notifications-circle-outline',
            message: `Qualcuno ha commentato ${type} che stai seguendo`,
            duration: 3000,
            cssClass: 'tabs-bottom',
            buttons: [{
                side: 'end', text: 'Controlla', handler: () => {
                    this.handleDealDetailNotification(idToOpen);
                }
            }]
        });
        await toast.present();
    }

    async presentToastNotificationNuoveOfferte(): Promise<void> {
        const toast = await this.toastController.create({
            color: 'medium',
            icon: 'notifications-circle-outline',
            message: 'Nuove offerte disponibili!',
            duration: 3000,
            cssClass: 'tabs-bottom',
            buttons: [{
                side: 'end', text: 'Controlla', handler: () => {
                    this.getAllDeals().subscribe(deals => {
                        this.dealsList.next(deals);
                        this.router.navigate(['/home/deals-list']).then(() => this.tabSelected.next('deals-list'));
                    });
                }
            }]
        });
        await toast.present();
    }

    async presentToastNotificationFavoritesList(): Promise<void> {
        const toast = await this.toastController.create({
            color: 'medium',
            icon: 'notifications-circle-outline',
            message: 'Il prodotto che volevi è ora in offerta!',
            duration: 3000,
            cssClass: 'tabs-bottom',
            buttons: [{
                side: 'end',
                text: 'Controlla',
                handler: () => this.onFavoritesListToastAction()
            }]
        });
        await toast.present();
    }

    private onFavoritesListToastAction(): void {
        this.getAllDeals().subscribe({
            next: deals => {
                this.dealsList.next(deals);
                this.navigateToSavedList();
            }
        });
    }

    private navigateToSavedList(): void {
        setTimeout(() => {
            this.router.navigate(['/home/saved-list'])
                .then(() => this.tabSelected.next('saved-list'));
        }, 300);
    }


    async presentToastNotification(typeToOpen: string): Promise<void> {
        const toast = await this.toastController.create({
            color: 'medium',
            icon: 'notifications-circle-outline',
            message: 'È arrivata una nuova notifica!',
            duration: 3000,
            cssClass: 'tabs-bottom',
            buttons: [{
                side: 'end', text: 'Controlla', handler: () => {
                    switch (typeToOpen) {
                        case LABEL.DEAL_DETAIL:
                            this.handleDealDetailNotification('');
                            break;
                        case LABEL.COMMUNICATION_DETAIL:
                            this.handleCommunicationNotification('');
                            break;
                        case LABEL.TUTORIAL_DETAIL:
                            this.handleTutorialNotification('');
                            break;
                    }
                }
            }]
        });
        await toast.present();
    }
}
